/*
 * @Author: zhang lin
 * @Date: 2022-05-05 16:14:17
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-15 15:45:56
 */
import React from 'react';
import styles from './index.less';
import List from 'root/components/FileConfig';

const MonitorManage = () => {
  return (
    <div className={styles.container}>
      <List />
    </div>
  );
};

export default MonitorManage;
